import { ExplicitHeight } from './explicit-height.js';
import { ExplicitWidth } from './explicit-width.js';

new ExplicitHeight();
new ExplicitWidth();